import { featurePosts } from "../../../mocks/anime";

export default function FeatureSection() {
  return (
    <section id="feature" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-8 text-center md:mb-10">
          <p className="mb-2 text-xs font-bold tracking-widest text-primary-600">专题攻略</p>
          <h2 className="font-display text-2xl text-foreground-950 md:text-4xl">
            恋爱番专题攻略，嗑糖有方法
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            从逆后宫入坑到暧昧攻略进阶，再到高甜日常补番，每篇专题都帮你把恋爱番的门道讲透。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featurePosts.map((post) => (
            <a
              key={post.id}
              href="#recommend"
              className="group overflow-hidden rounded-lg bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={post.image}
                  alt={`${post.title} 恋爱番专题攻略配图`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-bold text-white">
                  {post.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-display text-base text-foreground-950 transition-colors group-hover:text-primary-700">
                  {post.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600">
                  {post.excerpt}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-primary-600">
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}